import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    myTodos :[]as Object,
    progressTodo: []as Object,
    finishedTodo:  []as Object,
    categories:  []as Object,
    filteredby: null as null | string
  },
  mutations: {
    updateOrder(state:any,payload:any){
      switch (payload.status) {
        case "TODO":
          { 
              state.myTodos  = payload.data 
              // update data on the localStorage
              let TodosStringified = JSON.stringify(state.myTodos)
              return localStorage.setItem('todos', TodosStringified)
            }
        case "PROGRESS":
          { 
            state.progressTodo  = payload.data
            // update data on the localStorage
            let progressTodoStringified = JSON.stringify(state.progressTodo)
            return localStorage.setItem('progress', progressTodoStringified)
          }
        case "FINISHED":
          {  
            state.finishedTodo  = payload.data 
            //update data on the localStorage
            let finishedTodoStringified = JSON.stringify(state.finishedTodo)
            return localStorage.setItem('finished', finishedTodoStringified)
          }
        default: return state
      }
    },
    // Add new todo
    new_todo(state,payload)  {
      state.myTodos.push(payload)
      let TodosStringified = JSON.stringify(state.myTodos);
      localStorage.setItem('todos', TodosStringified)
      // add the category to the categories array if it's unique
      const category=state.myTodos.filter((todo:any)=>todo.category === payload.category) 
      if(category.length > 1) return;
      state.categories.push(category[0].category)
      let categoriesStringified = JSON.stringify(state.categories)
      return localStorage.setItem('categories', categoriesStringified)

   },
  //  Delete a todo
   delete_todo(state:any,payload:any){
    if(!payload) return;
    // Delete the Categoy of the todo
    function deleteCategory(data:any){
      const category      = data.filter((todo:any)=>todo.category === payload.data.category) 
      const categoryIndex = state.categories.map((category:any) => category).indexOf(category[0].category);
      if(category.length > 1) return // return if we have other todo using the same category
      state.categories.splice(categoryIndex,1)
      let categoriesStringified = JSON.stringify(state.categories)
      return localStorage.setItem('categories', categoriesStringified)
    }

    switch (payload.status) {
      case "TODO":
        { 
          deleteCategory(state.myTodos);
          state.myTodos=state.myTodos.filter((todo:any)=>todo.id != payload.data.id)
          let TodosStringified = JSON.stringify(state.myTodos)
          localStorage.setItem('todos', TodosStringified)
       
          return
        }
      case "PROGRESS":
        {  
          deleteCategory(state.progressTodo);
          state.progressTodo=state.progressTodo.filter((todo:any)=>todo.id != payload.data.id)
          let finishedTodoStringified = JSON.stringify(state.finishedTodo)
          localStorage.setItem('progress', finishedTodoStringified)
          return
        }
      case "FINISHED":
        {  
          deleteCategory(state.finishedTodo);
          state.finishedTodo=state.finishedTodo.filter((todo:any)=>todo.id != payload.data.id)
          let finishedTodoStringified = JSON.stringify(state.finishedTodo)
          localStorage.setItem('finished', finishedTodoStringified)
          return
        }
      default: return state
    }
   },
   filterTodos(state,payload){
    state.filteredby = payload
   },
   browerData(state){
    //  Get the data from Brawser(localStorage)
     state.myTodos=JSON.parse(localStorage.getItem("todos") || '[]')
     state.progressTodo=JSON.parse(localStorage.getItem("progress") || '[]')
     state.finishedTodo=JSON.parse(localStorage.getItem("finished") || '[]')
     state.categories=JSON.parse(localStorage.getItem("categories") || '[]')
   }
  },
  getters:{
    getTodos(state){
      return state.myTodos;
    },
    getCategories(state:any){
      return state.categories;
    },
    getFilterdby(state:any){
      return state.filteredby;
    }
  },
  actions: {
    updateOrder({commit},payload){
      commit({type:'updateOrder',
              data:payload.data,
              status:payload.status
            })
    },
    add_new_todo({commit},payload){
      commit('new_todo',payload)
      
    },
    filterby({commit},payload){
      commit('filterTodos',payload)
    },
    remove_todo({commit},payload){
      commit({type:'delete_todo',
              data:payload.data,
              status:payload.status
            })
    },
    get_data_from_borwser({commit}){
      commit('browerData');
    }
  },
})
